
const initSortable = () => {
  $('#course_accomplishments tbody').sortable({
    items: 'tr',

    handle: '.action-btn--move',

    helper(e, ui) {
      ui.children().each(function() { $(this).width($(this).width()); });
      return ui;
    },

    update(e, ui) {
      const request = new Kadenze.AjaxRequest({
        url: $(this).parent().attr('data-update-url'),
        data: $(this).sortable('serialize'),
        dataType: 'text',
        dataAsJSON: false,
        loadingIndicator: {
          container: $(this)
        }
      });

      request.done((data, textStatus, xhr) => {
        const $trs = $(this).children('tr');

        $trs.each(function() {
          const $tr = $(this);
          $tr.find('.in-table__order-num').html($tr.index() + 1);
        });
      });

      request.fail((xhr, textStatus, errorThrown) => {
        $('#course_accomplishments tbody').sortable('cancel');

        new Kadenze.Notice.error({
          parentObject: '.in-session-list',
          message: Kadenze.I18n.t('notice.unexpected_error')
        });
      });
    }
  });
};

export default {
  init(element) {
    initSortable();
  }
};

